import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EnglishArabicDTO, FilterItem, FilterType, InputType, MultiLingualTextBoxOptions, PagingOptions, TextBoxOptions } from 'bnsights-control-library';
import { DataSecretService } from '../../shared/Services/data.service';
import { SectorService } from '../../shared/Services/SectorService.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { SectorModel } from '../../shared/models/SectorModels/SectorModel';
import { UsersIDRequestModel } from '../../shared/models/UserModels/UsersIDRequestModel';
import { PageInfoService } from '../../../_metronic/core/services/page-info.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService, UtilityService, BBSFTranslateService, EnvironmentService } from 'bnsights-utilities-library';

@Component({
  selector: 'lib-sector',
  templateUrl: './sector.component.html'
})
export class SectorComponent implements OnInit {

  SubheaderTitle = this.utilityService.getResourceValue('Sectors');
  ShowToolbar = true;
  ShowbreadCrumb = false;
  ApiUrl = "/api/admin/Sector/"
  searchTextBox: TextBoxOptions;
  SectorForm = new FormGroup({});
  showFilter: boolean = false;
  SectorPagingResult: any[] = [];
  SectorPaging: PagingOptions;
  TextInputFilter: FilterItem;
  IsFilterLoaded: boolean = false;
  ProductionMode: boolean;
  @ViewChild('SectorPagingViewElement', { static: false }) input: ElementRef;


  //Add Model Controls
  AddSectorForm = new FormGroup({});
  MultiLingualName:MultiLingualTextBoxOptions
  IsAddSectorFormLoaded: boolean = false;
  @ViewChild('CloseSectorModal', { static: false }) CloseSectorModal: ElementRef;

  //Edit Model Controls
  EditSectorForm = new FormGroup({});
  EditMultiLingualName:MultiLingualTextBoxOptions
  IsEditSectorModelLoaded: boolean;
  SectorId: number;
  @ViewChild('CloseEditSectorModal', { static: false }) CloseEditSectorModal: ElementRef;

  //delete  Model Controls
  deleteSectorList: any[] = []
  IsOpenDeleteSectorModal: boolean = false
  @ViewChild('CloseDeleteSectorModal', { static: false }) CloseDeleteSectorModal: ElementRef;
  language:string=""
  // Decorator wires up blockUI instance
  @BlockUI() blockUI: NgBlockUI;
  ShowPageContent:boolean=false;


  constructor(private pageInfoService: PageInfoService,public utilityService:UtilityService,private bbsfTranslateService:BBSFTranslateService,private environmentService:EnvironmentService,private dataServices: DataSecretService, private authService: AuthService, private SectorService: SectorService, private modalService: NgbModal) {
  }

  async ngOnInit(): Promise<void> {
    this.ShowPageContent=true;
    PageInfoService.PageTitle=this.utilityService.getResourceValue("Sectors")
    PageInfoService.PageBreadcrumbs=[
       {title: this.utilityService.getResourceValue("Home") , path: '/Admin/Home', isSeparator: false, isActive: false},
       {title: '', path: '', isSeparator: true, isActive: false}

    ];
    this.pageInfoService.calculateTitle();
    this.pageInfoService.calculateBreadcrumbs();
    this.bbsfTranslateService.onLangChange.subscribe((event)=>{
      this.ShowPageContent=false;
      this.language = event.lang;
      this.ngOnInit();
    })
    this.language =  await this.utilityService.getCurrentLanguage();
    this.ProductionMode = this.environmentService.getProductionMode()
    this.LoadList();
  }

  LoadList() {
      // TextBox inti
    this.searchTextBox = new TextBoxOptions();
    this.searchTextBox.Name = "searchTextBox"
    this.searchTextBox.HideLabel = true
    this.searchTextBox.Type = InputType.Text
    this.searchTextBox.Placeholder = this.utilityService.getResourceValue("SearchByName")

      this.TextInputFilter = new FilterItem();
      this.TextInputFilter.FormControlName = "searchTextBox"
      this.TextInputFilter.ActionParameterName = "searchText"
      this.TextInputFilter.IsFormControl = true
      this.TextInputFilter.FilterType = FilterType.TextBox

      this.SectorPaging = new PagingOptions();
      this.SectorPaging.ActionPostURL = this.environmentService.getApiUrl() + this.ApiUrl + 'GetSectorsByFilter';
      this.SectorPaging.OnKeyPressFiltersControlNames = ["searchTextBox"]
      this.SectorPaging.Filters = [this.TextInputFilter]
      this.SectorPaging.ValidationToken = this.authService.authorizationHeaderValue()
      this.IsFilterLoaded = true;
       
  }

  ReinitializeSectorPaging() {
    let element = this.input as any;
    element.ReinitializePaging();
  }

  UpdateSectorPaging() {
    let element = this.input as any;
    element.UpdatePaging();
  }

  setSectorListResult(result) {
    this.SectorPagingResult= result
    this.ShowPageContent=true;
    this.utilityService.stopBlockUI()
  }

  resetFilters() {
    this.SectorForm.controls["searchTextBox"].setValue(null);
    let element = this.input as any;
    element.ReinitializePaging();
  }

  showAddSectorModal(AddSectorModal) {
    this.utilityService.startBlockUI();
    this.AddSectorForm = new FormGroup({})

    this.MultiLingualName = new MultiLingualTextBoxOptions();
    this.MultiLingualName.Name = "Name";
    this.MultiLingualName.ArabicLabelKey = "NameInArabic";
    this.MultiLingualName.EnglishLabelKey = "NameInEnglish";
    this.MultiLingualName.IsRequired = true;
    this.MultiLingualName.Value = null;
    this.modalService.open(AddSectorModal);
    this.utilityService.stopBlockUI();

  }

  addSector() {
    if (this.AddSectorForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.AddSectorForm.value;
      let AddModel:SectorModel= new SectorModel() ;
      AddModel.Name.Arabic = ResultModel.Name.ArabicValue;
      AddModel.Name.English = ResultModel.Name.EnglishValue;
      this.SectorService.AddSector(AddModel).subscribe((result) => {
        this.modalService.dismissAll();
        let element = this.input as any;
        element.ReinitializePaging();
      }, (error) => {
       
      })
    }
  }


  showEditSectorModal(Sector: any, EditSectorModal) {

    this.utilityService.startBlockUI();
    this.EditSectorForm = new FormGroup({})

    let Name=new EnglishArabicDTO();
    Name.Arabic=Sector.name.arabic;
    Name.English=Sector.name.english;

    this.EditMultiLingualName = new MultiLingualTextBoxOptions();
    this.EditMultiLingualName.Name = "Name";
    this.EditMultiLingualName.ArabicLabelKey = "NameInArabic";
    this.EditMultiLingualName.EnglishLabelKey = "NameInEnglish";
    this.EditMultiLingualName.IsRequired = true;
    this.EditMultiLingualName.Value = Name;
    
  

    this.SectorId = Sector.id
    this.modalService.open(EditSectorModal);
    this.utilityService.stopBlockUI();


  }

  editSector() {
    if (this.EditSectorForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.EditSectorForm.value;
      let EditModel:SectorModel= new SectorModel() ;
      EditModel.Id = this.SectorId;
      EditModel.Name.Arabic = ResultModel.Name.ArabicValue;
      EditModel.Name.English = ResultModel.Name.EnglishValue;
      this.SectorService.EditSector(EditModel).subscribe((result) => {
        this.modalService.dismissAll();
        let element = this.input as any;
        element.UpdatePaging();
      }, (error) => {
        
      })
    }
  }

  showDeleteSectorModal(Sector: any, deleteSectorModal) {
    this.deleteSectorList = []
    this.deleteSectorList.push(Sector);
    this.IsOpenDeleteSectorModal = false;
    this.utilityService.startBlockUI();
    this.modalService.open(deleteSectorModal);
    this.utilityService.stopBlockUI();


  }

  deleteSector() {
    let  UsersIDModel:UsersIDRequestModel= new UsersIDRequestModel() ;
     for (let index = 0; index < this.deleteSectorList.length; index++) {
       const element = this.deleteSectorList[index];
       UsersIDModel.UsersIDs.push(element.id)
       
     }
    this.SectorService.DeleteSector(UsersIDModel ).subscribe((result) => {
      this.deleteSectorList = [];
      this.modalService.dismissAll();
      let element = this.input as any;
      element.ReinitializePaging();
    }, (error) => {
     
    })

  }


}
